export const getTime = () => {
  const now = new Date();
  const hourOfDay = now.getHours();

  if (hourOfDay >= 5 && hourOfDay < 12) {
    return "morning";
  }
  if (hourOfDay >= 12 && hourOfDay < 17) {
    return "afternoon";
  }
  if (hourOfDay >= 17 && hourOfDay < 21) {
    return "evening";
  }
  if (hourOfDay >= 21 || hourOfDay < 5) {
    return "night";
  }
  return "day";
};

export const random = (min, max) => {
  return Math.random() * (max - min + 1);
};
